import React from 'react';
import PropTypes from 'prop-types';

const POIBadges = (props) => {
  const badges = props._source.badges_urls;

  return (
    <div className="sk-hits-list-hit__badges">
      {badges.slice(0, 5).map((badge, i) => (
          <img alt={props._source.name} src={badge} key={i} />
      ))}
      {badges.length > 5 &&
        <div className="more">+{badges.length - 5}</div>
      }
    </div>
  )
}

POIBadges.propTypes = {
  _source: PropTypes.shape({
    name: PropTypes.string.isRequired,
    badges_urls: PropTypes.array
  })
};

export default POIBadges;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POIBadges.jsx